import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import './aside.css'
import './layouts.css'

const CustomerSupportAside = () => {
    const [empId, setEmpId] = useState('');
    const [empName, setEmpName] = useState('');
    const [designation, setDesignation] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        () => localStorage.getItem('mobileSidebarOpen') === 'true'
    );
    const navigate = useNavigate(); // to logout when click on logout button 

    // Effect to load employee details from localStorage
    useEffect(() => {
        const storedEmpId = localStorage.getItem('empId');
        const storedEmpName = localStorage.getItem('empName');
        const storedDesignation = localStorage.getItem('designation');

        // If employee details are missing, show alert and navigate to homepage
        if (!storedEmpId || !storedEmpName || !storedDesignation) {
            alert('Session expired. Please log in again.');
            navigate('/'); // Navigate to homepage (not necessarily the login page)
        } else {
            setEmpId(storedEmpId);
            setEmpName(storedEmpName);
            setDesignation(storedDesignation);
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('empId');
        localStorage.removeItem('empName');
        localStorage.removeItem('designation');
        navigate('/'); // Redirect to homepage after logout
    };

    const handleSidebarToggle = () => {
        setIsSidebarOpen((prev) => {
            const next = !prev;
            localStorage.setItem('mobileSidebarOpen', String(next));
            return next;
        });
    };



    return (
        <div className={`sideBar ${isSidebarOpen ? 'is-open' : ''}`}>
            <button
                type="button"
                className="mobile-sidebar-toggle"
                aria-label="Toggle sidebar"
                aria-expanded={isSidebarOpen}
                onClick={handleSidebarToggle}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className="imageBlock">
                {/* <img src={profile} alt="" /> */}

            </div>
            <div className="employeeDetails">
                <h4>Employee ID :<span className="empvalues">{empId} </span></h4>
                <h4>Employee Name :<span className="empvalues">{empName}</span></h4>
                <h4>Designation :<span className="empvalues">{designation}</span></h4>
            </div>

            {designation === "Customer Support Exicutive" ?
                <div className="linkDiv">
                    <Link className="links" to={'/C_S_Data'}  >Data</Link><br />
                    <Link className="links" to={'/C_S_Centralization'} >Centralisation</Link><br />
                    <Link className="links" to={'/C_S_Followup'} >Follow-up</Link><br />
                    <Link className="links" to={'/C_S_checklist'} >Check List</Link><br />

                    <div className="logout-container">
                        <button onClick={handleLogout} className="logout-button">
                            Logout
                        </button>
                    </div>
                </div>
                :
                <div className="linkDiv">
                    <Link className="links" to={'/C_S_M_Data'}>Data</Link><br />
                    <Link className="links" to={'/C_S_M_Centralization'}>Centralisation</Link><br />
                    <Link className="links" to={'/C_S_M_follow_up'}>Follow-up</Link><br />
                    <Link className="links" to={'/C_S_M_Checklist'}>Check List</Link><br />

                    <div className="logout-container">
                        <button onClick={handleLogout} className="logout-button">
                            Logout
                        </button>
                    </div>

                </div>
            }
        </div>
    )
}

export default CustomerSupportAside